// Helper to get sample count from path, checking alternative field names
function getPathSampleCount(path) {
  // Check various possible field names from intelligence service
  const count = path.sample_count ?? path.samples ?? path.count ?? path.total_samples;
  if (count !== undefined && count !== null) {
    return count;
  }
  // Fallback: calculate from successes + failures if available
  if (path.successes !== undefined && path.failures !== undefined) {
    return (path.successes || 0) + (path.failures || 0);
  }
  return 0;
}

export function getAgentStatus(agent) {
  const paths = agent.paths || [];
  const totalSamples = paths.reduce((sum, p) => sum + getPathSampleCount(p), 0);
  const execCount = agent.execCount || agent.stats?.total_decisions || 0;
  const hasLeader = paths.some(p => p.status === 'leader');
  const leader = paths.find(p => p.status === 'leader');

  // Use execution count as fallback if sample_count isn't populated
  const hasData = totalSamples > 0 || execCount > 0;

  // Debug logging
  console.log('getAgentStatus:', agent.goal, { totalSamples, execCount, hasData, hasLeader });

  if (paths.length === 0) {
    return {
      state: 'waiting',
      title: 'No paths registered',
      subtitle: 'Register paths using the SDK to start routing',
      progress: null,
    };
  }

  // Only show "waiting" if we truly have NO data
  if (!hasData) {
    return {
      state: 'waiting',
      title: 'Waiting for data',
      subtitle: 'Run your agent to start collecting outcomes',
      progress: null,
    };
  }

  if (hasLeader && leader) {
    const successRate = Math.round((leader.success_rate || 0) * 100);
    const leaderSamples = getPathSampleCount(leader) || execCount;
    return {
      state: 'optimized',
      title: `${leader.model_id} is winning`,
      subtitle: `${successRate}% success rate · ${leaderSamples} decisions`,
      leader,
      progress: null,
    };
  }

  // We have data but no leader yet = learning
  const dataCount = totalSamples || execCount;
  const minSamplesPerPath = 20;
  const totalNeeded = paths.length * minSamplesPerPath;

  return {
    state: 'learning',
    title: 'Collecting data',
    subtitle: `${dataCount} executions · Traffic split evenly for learning`,
    progress: { current: dataCount, total: totalNeeded },
  };
}

export function formatRelativeTime(date) {
  if (!date) return 'No activity yet';
  const now = new Date();
  const then = new Date(date);
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
}

export function formatGoalName(goal) {
  if (!goal) return '';
  return goal.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
